import { OnInit, Component } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';


@Component({
    selector: 'app-reset-password-request-form',
    templateUrl: './reset-password-request-form.component.html'
})
export class ResetPasswordRequestFormComponent implements OnInit {
    resetPasswordRequestForm: FormGroup;
    loading = false;
    submitted = false;

    constructor(private accountService: AccountService, private router: Router) {}

    ngOnInit() {
        this.resetPasswordRequestForm = new FormGroup({
            email: new FormControl(null, [Validators.required, Validators.email])
        });
    }

    get f() {
        return this.resetPasswordRequestForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        if (this.resetPasswordRequestForm.invalid) {
            return;
        }

        this.loading = true;
        this.accountService.startResetPassword(this.resetPasswordRequestForm.value).subscribe(() => {
            this.loading = false;
            this.router.navigate(['login']);
        }, error => {
          this.loading = false;
        });
    }
}
